// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lm-exam-fill-blank .exam-fill-answer{padding-top:30px}.lm-exam-fill-blank .exam-fill-answer .exam-fill-answer-box{background:transparent;border:1px solid #fff;border-radius:4px;height:30px;width:50%;color:#fff;font-size:16px;padding:0 4px}.lm-exam-fill-blank .exam-fill-answer .mark{padding-left:20px}.lm-exam-fill-blank .exam-fill-answer .mark i{font-size:20px;font-weight:600;color:#ff0}.lm-exam-fill-blank .exam-fill-answer .mark .el-icon-close{color:red}", ""]);
// Exports
module.exports = exports;
